/* DSL Meta Pixel events — fires when fbq is loaded + consent.marketing === true */
(function(){
  function ready(cb){
    var iv = setInterval(function(){
      if (typeof window.fbq === "function") { clearInterval(iv); cb(); }
    }, 200);
    setTimeout(function(){ clearInterval(iv); }, 10000);
  }
  ready(function(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.marketing === false) return;
    if (location.pathname.indexOf("/products/") === 0) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) fetch("/products/" + m[1] + ".js").then(function(r){return r.json();}).then(function(p){
        fbq("track", "ViewContent", {content_ids: [String(p.id)], content_name: p.title, content_type: "product", value: p.price/100, currency: "EUR"});
      });
    }
    document.addEventListener("dsl:cart:add", function(e){
      var d = e.detail || {};
      fbq("track", "AddToCart", {content_ids: [String(d.variant_id||d.product_id)], content_name: d.product_title, content_type: "product", value: (d.price||0)/100, currency: "EUR"});
    });
    if (location.pathname === "/cart") {
      fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
        if (c.item_count > 0) fbq("track", "InitiateCheckout", {value: c.total_price/100, currency: "EUR", num_items: c.item_count});
      });
    }
    var q = new URLSearchParams(location.search).get("q");
    if (q && location.pathname === "/search") fbq("track", "Search", {search_string: q});
  });
})();